export default "__VITE_ASSET__B1B09wih__"